import { render, staticRenderFns } from "./dictionaries.vue?vue&type=template&id=5e1e34d0&scoped=true&"
import script from "./dictionaries.vue?vue&type=script&lang=js&"
export * from "./dictionaries.vue?vue&type=script&lang=js&"
import style0 from "./dictionaries.vue?vue&type=style&index=0&id=5e1e34d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1e34d0",
  null
  
)

export default component.exports